import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-chat',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map